import React, {useState} from 'react';
import {Modal} from './UI/Modal';
import {Button} from './UI/Button';

const Header = () => {
  const [ isModalOpen, setIsModalOpen ] = useState(false);

  return (
    <>
      <div className='sticky flex items-center top-0 bg-white border-b border-slate-200 w-full h-16 z-40'>
        <div className='flex justify-between items-center w-full lg:w-1/2 lg:mx-auto px-8 lg:px-0'>
          <div className='flex items-center '>
            <img src='/logo.svg' width={50} height={50} />
            <h1 className='text-2xl font-semibold ml-3 uppercase text-[#058ff4]'>Sierra Signature Center</h1>
          </div>
          <div className='flex'>
            <Button
              type="button"
              size='sm'
              color='blue'
              onClick={() => setIsModalOpen(true)}
            >
              How to install
            </Button>
          </div>
        </div>
      </div>

      <Modal isOpen={isModalOpen} setIsOpen={() => setIsModalOpen(false)}>
        <video width="100%" height="auto" controls={true} playsInline>
          <source src="/tutorial.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Modal>
    </>
  );
};

export default Header;